import React, { useMemo } from "react";
import {
  Dialog,
  DialogContent,
  makeStyles,
  withStyles,
  Typography,
} from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle";

import styles from "./styles";
const useStyles = makeStyles(styles);

const DialogTitle = withStyles(styles)((props) => {
  const { title, subtitle, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle
      disableTypography
      className={classes.headerDialog}
      {...other}
    >
      <Typography variant="h5">{title}</Typography>
      <Typography variant="h6">{subtitle}</Typography>
    </MuiDialogTitle>
  );
});

function DialogComponent(props) {
  const classes = useStyles();
  const { open, onClose, maxWidth, title, subtitle, children } = props;
  
  const modalMaxWidth = useMemo(() => {
    if (!maxWidth) return "md";
    return maxWidth;
  }, [maxWidth]);

  return (
    <Dialog
      fullWidth={true}
      maxWidth={modalMaxWidth}
      open={open}
      onClose={onClose}
      scroll={"body"}
    >
      {title && (
        <DialogTitle
          title={title}
          subtitle={subtitle}
          className={classes.headerDialog}
        />
      )}
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
}

export default DialogComponent;
